import React, { useState, useEffect } from 'react';
import { Popover, Group, CloseButton, Stack, Radio } from '@mantine/core'; 
import ColorButton from '../Buttons/ColorButton';

const UniversalRadioFilter = ({
  filterName,           // e.g., "Status"
  options,              // Array of { label: string, value: string }
  selectedValue,        // The currently applied value from the parent
  defaultResetValue = 'All', // The value to revert to when clearing
  popoverTitle,         // e.g., "Nachrichtenstatus auswählen"
  isMobile = false,
  onApply,              // Callback when user clicks "Anwenden": (newValue) => void
  onReset,              // Callback when user clicks "Abbrechen" or the 'X' button
}) => {
  const [opened, setOpened] = useState(false);
  const [draftValue, setDraftValue] = useState(selectedValue);

  // Sync the draft value with the parent's value whenever the popover opens
  // This ensures if a user cancels, the next time they open it, it resets to the applied value
  useEffect(() => {
    if (opened) {
      setDraftValue(selectedValue);
    }
  }, [opened, selectedValue]);

  const handleApply = () => {
    onApply(draftValue);
    setOpened(false);
  };

  const handleResetAction = (e) => {
    e.stopPropagation(); // Prevent the click from simultaneously opening the popover
    setDraftValue(defaultResetValue);
    if (onReset) onReset();
    setOpened(false);
  };

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      withArrow={false}
    >
      {/* V7 FIX: The trigger must be wrapped in Popover.Target */}
      <Popover.Target>
        <Group
          className="selected-card-filter"
          gap={7} // V7 FIX: spacing is now gap
          wrap="nowrap" // V7 FIX: noWrap is now wrap="nowrap"
          onClick={() => setOpened((o) => !o)}
          style={{ marginBottom: isMobile ? '15px' : 0, cursor: 'pointer' }}
        >
          <span style={{ whiteSpace: 'nowrap', maxWidth: isMobile ? '100px' : undefined, textOverflow: 'ellipsis', overflowX: 'hidden' }}>
            {`${filterName}: ${options.find((o) => o.value === selectedValue)?.label || selectedValue}`}
          </span>
          {selectedValue !== defaultResetValue && (
            <Group>
              <CloseButton
                onMouseDown={handleResetAction}
                variant="transparent"
                size={15}
                iconSize={14}
                tabIndex={-1}
              />
            </Group>
          )}
        </Group>
      </Popover.Target>

      {/* V7 FIX: Content must be wrapped in Popover.Dropdown */}
      <Popover.Dropdown p="md">
        <Stack gap={30}>
          {popoverTitle && (
            <div style={{ fontSize: '14px', fontWeight: 500 }}>
              {popoverTitle}
            </div>
          )}
          
          <Stack gap={15}>
            {/* V7 FIX: RadioGroup is now Radio.Group */}
            <Radio.Group
              value={draftValue}
              onChange={(val) => setDraftValue(val)}
            >
              {/* V7 FIX: orientation="vertical" is removed. Wrap items in a Stack to achieve vertical layout */}
              <Stack gap="xs">
                {options.map((option) => (
                  <Radio 
                    key={option.value} 
                    value={option.value} 
                    label={option.label} 
                    classNames={{
                      input: 'tenants-list-checkbox-rental-income-input', 
                      inner: 'tenants-list-checkbox-rental-income-inner'
                    }}
                    styles={{
                      label: { fontSize: '14px', marginBottom: 0 }
                    }}
                  />
                ))}
              </Stack>
            </Radio.Group>
          </Stack>
          
          {/* V7 FIX: position="apart" is now justify="space-between" */}
          <Group justify="space-between">
            <div>
              <ColorButton
                text="Abbrechen"
                className="gray-btn"
                onClick={handleResetAction}
              />
            </div>
            <div>
              <ColorButton
                text="Anwenden"
                className="purple-btn"
                onClick={handleApply}
              />
            </div>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default UniversalRadioFilter;